
import { DownOutlined } from '@ant-design/icons';
import { Form, TreeSelect } from 'antd';
import React from 'react'

const TreeSelectUC = (props) => {
    const { SHOW_PARENT } = TreeSelect;
    const {
        name,
        label,
        treeData,
        value,
        treeCheckable = true,
        showCheckedStrategy = SHOW_PARENT,
        placeholder,
        onChange,
        required,
        disabled,
        hidden,
        suffixIcon = null,
        treeDefaultExpandAll = true,
        ...prop } = props;

    return (
        <>
            <Form.Item
                label={label}
                name={name}
                rules={required ? [{ required: true, message: 'กรุณาเลือก ' + label }] : ''}
                initialValue={value ? value : ''}
            >
                <TreeSelect
                    // name={name}
                    onChange={onChange}
                    disabled={disabled}
                    suffixIcon={suffixIcon ? suffixIcon : <DownOutlined />}
                    treeDefaultExpandAll={treeDefaultExpandAll}
                    placeholder={placeholder ? placeholder : "กรุณาเลือก"}
                    treeCheckable={treeCheckable}
                    showCheckedStrategy={showCheckedStrategy}
                    treeData={treeData}
                    maxTagCount="responsive"
                    maxTagPlaceholder={(treeData) => `+ ${treeData.length} ...`}
                    {...prop}
                />
            </Form.Item>
        </>
    )
}

export default TreeSelectUC